import { useState } from "react";
import { motion } from "framer-motion";
import { X, Play } from "lucide-react";

const items = [
  {
    type: "image",
    url: "https://customer-assets.emergentagent.com/job_wedding-wheels-sk/artifacts/3zqikt5u_IMG_2734.jpeg",
    title: "V lese — Tatra 603",
    span: "md:col-span-7 md:row-span-2",
  },
  {
    type: "image",
    url: "https://customer-assets.emergentagent.com/job_wedding-wheels-sk/artifacts/p4klg32m_2A66B4DC-5B09-4F40-82C2-210E1F6A484C.png",
    title: "Svadobný deň",
    span: "md:col-span-5",
  },
  {
    type: "video",
    url: "https://customer-assets.emergentagent.com/job_wedding-wheels-sk/artifacts/mp2k7a5o_6843C21A-3123-47A3-B912-0AB459C2554A.mov",
    title: "Naštartovaná — zvuk legendy",
    span: "md:col-span-5",
  },
];

export default function Gallery() {
  const [active, setActive] = useState(null);

  return (
    <section
      id="galeria"
      data-testid="gallery-section"
      className="relative py-24 sm:py-36 bg-[#0a0a0a] border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="text-center mb-16">
          <span className="ornament">Galéria</span>
          <h2 className="font-serif font-light text-4xl sm:text-5xl tracking-tight text-cream mt-6 leading-[1.05]">
            Niekoľko okamihov
            <br />
            <em className="text-gold italic font-light">v plnej kráse.</em>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 auto-rows-[300px] gap-4 md:gap-5">
          {items.map((it, i) => (
            <motion.button
              key={it.url}
              type="button"
              onClick={() => setActive(it)}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.06 }}
              className={`group relative overflow-hidden border border-white/10 hover:border-gold/50 transition-colors duration-500 ${it.span}`}
            >
              {it.type === "video" ? (
                <video
                  src={it.url}
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="w-full h-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105"
                />
              ) : (
                <img
                  src={it.url}
                  alt={it.title}
                  className="w-full h-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-110"
                />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent opacity-90 group-hover:opacity-100 transition-opacity" />
              {it.type === "video" && (
                <div className="absolute top-5 right-5 flex items-center gap-2 px-3 py-1.5 bg-black/60 backdrop-blur border border-gold/40 text-[10px] uppercase tracking-[0.25em] text-gold">
                  <Play size={11} fill="currentColor" /> Video
                </div>
              )}
              <div className="absolute left-6 bottom-6 right-6 text-left">
                <span className="text-[10px] uppercase tracking-[0.3em] text-gold/90">
                  0{i + 1} / Tatra 603
                </span>
                <div className="font-serif text-xl text-cream mt-1 font-light">
                  {it.title}
                </div>
              </div>
            </motion.button>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {active && (
        <div
          data-testid="gallery-lightbox"
          className="fixed inset-0 z-[60] bg-black/95 backdrop-blur-sm flex items-center justify-center p-6"
          onClick={() => setActive(null)}
        >
          <button
            data-testid="gallery-close"
            aria-label="Zavrieť"
            onClick={() => setActive(null)}
            className="absolute top-6 right-6 text-cream/80 hover:text-gold p-2"
          >
            <X size={28} />
          </button>
          {active.type === "video" ? (
            <video
              src={active.url}
              controls
              autoPlay
              playsInline
              className="max-w-full max-h-[85vh] object-contain border border-gold/30"
              onClick={(e) => e.stopPropagation()}
            />
          ) : (
            <img
              src={active.url}
              alt={active.title}
              className="max-w-full max-h-[85vh] object-contain border border-gold/30"
              onClick={(e) => e.stopPropagation()}
            />
          )}
        </div>
      )}
    </section>
  );
}
